/**
 * Tax / Social Insurance ページで共通利用する DOM ユーティリティ。
 *
 * 計算ロジックは @api-lib/taxCalc / @api-lib/socialCalc に分離し、
 * このファイルは「結果を DOM に書き込む」処理のみを担う。
 */

/** 金額を日本円カンマ区切りで文字列化する */
export function yen(n: number): string {
  return Math.round(n).toLocaleString('ja-JP');
}

/** 値を円表示し、0 円なら .tax-result-value--zero クラスを付与する */
export function setYenWithZeroClass(el: HTMLElement | null, value: number): void {
  if (!el) return;
  const v = Math.round(value);
  el.textContent = yen(v);
  el.classList.toggle('tax-result-value--zero', v === 0);
}

/**
 * querySelector で要素を取得して hidden 属性を操作するユーティリティ。
 * Tax / Social の入力フォーム切り替えに多用する。
 */
export function setHidden(root: ParentNode, id: string, hide: boolean): void {
  const el = root.querySelector<HTMLElement>(id);
  if (el) el.hidden = hide;
}
